module.exports = __webpack_public_path__ + "img/heating-gas-furnance.5f191ac2.jpg";